//
// locales/vanilla/hi.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/hi.json';
import localeData from 'react-intl/locale-data/hi.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
